import axios from 'axios';

import storage from './storage.js';

async function loadFolders(baseUrl, token) {
	if (!token) {
		token = await storage.getStorage();
	}

	let config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	if (baseUrl[baseUrl.length - 1] == '/') {
	} else {
		baseUrl = baseUrl + '/';
	}

	let url = `${baseUrl}folder`;

	let response = await axios.get(url, config).catch((err) => {
		throw err;
	});

	let data = [];

	if (response && response.data) {
		data = response.data;
	}

	if (typeof data === 'string') {
		data = [];
	}

	return data;
}

export default loadFolders;
